// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { pr, mx } from 'styled-components-spacing';
import Separator from '@components/Separator';

import theme from '@theme';
import { StyledWhatsappButton } from '@lib/styles/buttons';

import { SearchIcon, WhatsappIcon } from '@images/svg/index';

export const StyledNavigationCover = styled.div`
  box-sizing: border-box;
  align-items: center;
  display: flex;
  justify-content: space-between;
  ${pr(3)}
  border-bottom: ${props => (props.heroSection ? 'none' : 'solid 1px rgba(36, 42, 56, 0.1)')};
  width: ${props => (props.heroSection ? '100%' : '')};
  top: 0px;

  z-index: 999;

  position:  ${props => (props.heroSection ? 'fixed' : 'sticky')};
  background-color:  ${props => (props.heroSection ? 'transparent' : `${theme.colors.white}`)};

  height: 56px;

  ${breakpoint('desktop')`
    height: 80px;
  `}
`;

export const StyledWhatsppFloatButton = styled(StyledWhatsappButton)`
  // background: linear-gradient(
  //   93.36deg,
  //   #5aaac6 3.14%,
  //   #5cb1c5 33.15%,
  //   #62cbc1 67.04%,
  //   #64d2c1 96.08%
  // );
  background: #25D366;
  height: 40px;
  max-width: 40px;
  transition: all 1s;
  border-radius: 40px;

  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 1100;

  svg {
    height: 40px;
    width: 40px;
    margin-right: 24px !important;
  }

  ${breakpoint('mobile', 'desktop')`
  display: none;
  right: 5.5rem;
  top: 0.5rem;
  height: 20px;
  max-width: 20px;
  border-radius: 50%;
  padding: 10px;
  margin-bottom: 0;
  svg{
    height: 20px;
    width: 20px;
      margin-right: 0px !important;
     }  
  `}

  ${breakpoint('desktop')`
     div {
    margin-left: calc(30px + 1rem);
    overflow-x: hidden;
    ::-webkit-scrollbar {
      display: none;
    }
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
  }
  :hover {
    max-width: 500px;
    border-radius: 40px;
  }
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 200;

  svg {
    margin-right: 0px;
    position: absolute;
    left: 1rem;
    height: 40px;
    width: 40px;
    margin-right: 24px !important;
  }
  `}

  ${({ hide }) => hide && 'display: none'};
`;

export const StyledConnectMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 24px;

  ${breakpoint('mobile', 'desktop')`
    font-size: 16px;
    display: none;
  `}
`;

export const StyledWhatsppFloatButtonMobile = styled.a`
  position: fixed;
  top: 0.5rem;
  right: 5.5rem;
  height: 25px;
  width: 25px;
`;

export const StyledSeparator = styled(Separator)`
  ${({ vertical }) => (vertical ? 'height: 18px;' : 'height: 1px;')}

  ${breakpoint('desktop')`
    ${mx(3)}
  `}

  ${breakpoint('largeDesktop')`
    ${mx(4)}
  `}
`;

export const StyledLinkContainer = styled.div`
  display: none;

  ${breakpoint('desktop')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
  `}
`;

export const StyledMobileCtaSeparator = styled.div`
  width: 1px;
  height: 60%;
  background: ${theme.colors.formSeparator};

  margin-top: 5px;
  margin-right: 32px;
  margin-left: 8px;
`;

export const SearchIconImg = styled(SearchIcon)`
  height: 22px;
  margin-right: 35px;
  padding: 10px;
  ${({ heroSection }) => (heroSection && `
     fill: white;
     path{
      fill: white;
     }
    `)}
  ${breakpoint('desktop')`
    display: none;
  `}
`;

export const StyledWhatsapp = styled(WhatsappIcon)`
  display: none;
  ${breakpoint('mobile', 'desktop')`
      display: block;
      height: 20px;
      width: 20px;
      & path {
        fill: '#25D366';
      }
  `}
`;

export const StyledWhatsappWrapper = styled.a`
  display: none;

  ${breakpoint('mobile', 'desktop')`
      height: 20px;
      display: block;
      width: 20px;
      position: fixed;
      right: 6rem;
      `}
`;
